"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Address = exports.isAddress = void 0;
const validation_1 = require("../validator/validation");
const ValidatorClass_1 = require("../validator/ValidatorClass");
exports.isAddress = (0, validation_1.isObjectOf)({
    name: (0, validation_1.optional)(validation_1.isString.which((0, validation_1.matchesRegExp)(/../))),
    streetAddress: (0, validation_1.optional)(validation_1.isString.which((0, validation_1.matchesRegExp)(/\w+/))),
    postalCode: (0, validation_1.optional)(validation_1.isString),
    city: (0, validation_1.optional)(validation_1.isString.which((0, validation_1.matchesRegExp)(/\w+/))),
    state: (0, validation_1.optional)(validation_1.isString.which((0, validation_1.matchesRegExp)(/\w+/))),
    country: validation_1.isString,
});
class Address extends (0, ValidatorClass_1.ValidatorClass)(exports.isAddress) {
}
exports.Address = Address;
//# sourceMappingURL=Address.js.map